import { ClipLoader, BeatLoader } from "react-spinners";
import React from "react";

const Cliploader = () => {
  return (
    <ClipLoader
      color="#ff9b44"
      loading
      margin={2}
      size={50}
      speedMultiplier={1}
    />
  );
};

const Beatloader = () => {
  return (
    <BeatLoader color="#fff" loading margin={2} size={10} speedMultiplier={1} />
  );
};

export { Cliploader, Beatloader };
